
import barba from '@barba/core';
import KeenSlider from 'keen-slider'
import Swiper from 'swiper';

export default class{

	constructor(){

        // barba.hooks.beforeOnce((data) => {
        //     this.heroSlider()
        //     this.indexAboutSlider()
        //     this.worksSlider()
        //     this.insuranceSlider()
        //     // this.blogSlider()
        //     // this.pickupSlider()
        //     // this.eventSlider()

        // })
        // barba.hooks.after((data) => {
        //     this.heroSlider()
        //     this.indexAboutSlider()
        //     this.worksSlider()
        //     this.insuranceSlider()
        //     // this.blogSlider()
        //     // this.pickupSlider()
        //     // this.eventSlider()
        // });
        this.heroSlider()
        this.indexAboutSlider()
        this.worksSlider()
        this.insuranceSlider()
        this.intraEstateSlider()
        this.divisionSlider()
        this.golfSlider()
    }
    
        
    
    heroSlider(){
        setTimeout(() => {
            new Swiper ('#hero--slider',{
                loop: true,
                effect :'fade',
                speed:3000,
                allowTouchMove :false,
                simulateTouch:false,
                autoplay: {
                    delay: 5000
                }
            })
        },2000);
    }

    indexAboutSlider(){

        const indexAbout = document.querySelector("#p-index__about");
        if(indexAbout) {
            const animation = { duration: 15000, easing: (t) => t }
            new KeenSlider('.p-index__about--slider', {
                loop: true,
                //mode:'free',
                // renderMode: "performance",
                // drag: false,
                vertical: true,
               
                slides: {
                    origin: "center",
                    perView: 2.3,
                    spacing: 30,
                },
                breakpoints: {
                    "(max-width: 991px)": {
                        vertical: false,
                        slides: { perView: 3, spacing: 20 },
                    },
                    "(max-width: 767px)": {
                        vertical: false,
                        slides: { perView: 2.5, spacing: 20 },
                    },
                    "(max-width: 575px)": {
                        vertical: false,
                        slides: { perView: 2.2, spacing: 15 },
                    },
                },
                created(s) {
                    s.moveToIdx(1.3, true, animation)
                },
                updated(s) {
                    s.moveToIdx(s.track.details.abs + 1, true, animation)
                },
                animationEnded(s) {
                    s.moveToIdx(s.track.details.abs + 1, true, animation)
                },
            });
        }
    }
    
    worksSlider(){
        const thumbnails = document.querySelectorAll('.js-works__slider--thumbnails a');
        const worksSlider = new Swiper('.js-works__slider', {
            loop: false,
            speed:400,
            easing:"linear",
            loopAdditionalSlides : 5,
            slidesPerView: 'auto',
            spaceBetween: 20,
            simulateTouch:true,
            centeredSlides: false,
            navigation:  {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        
        
        const blogThumbnailAddEvent = (el,i) => {
            el.addEventListener('click',(e) => {
                e.preventDefault()
                worksSlider.slideTo(i)
            })
        }

        worksSlider.on('slideChange', function () {
            
            thumbnails.forEach( (t,i)=> {
                if(i === worksSlider.realIndex){
                    t.classList.add("-active")
                } else{
                    t.classList.remove("-active")
                }
            })
        })

        if(thumbnails.length > 0 ){
            thumbnails.forEach( (t,i)=> {
                blogThumbnailAddEvent(t,i)
            })
        }
    }

    insuranceSlider(){
        new Swiper ('#p-insurance__slide',{
            loop: true,
            effect :'slide',
            speed:2000,
            slidesPerView: 1.5,
            centeredSlides: true,
            allowTouchMove :false,
            // simulateTouch:false,
            autoplay: {
                delay: 4000
            },
            navigation:  {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: "#p-insurance__slider--wrapper .swiper-pagination",
                clickable: true,
            },
        })
    }

    intraEstateSlider(){
        new Swiper ('#p-intra-estate__slide',{
            loop: true,
            effect :'slide',
            speed:2000,
            slidesPerView: 1.5,
            centeredSlides: true,
            allowTouchMove :false,
            // simulateTouch:false,
            autoplay: {
                delay: 4000
            },
            navigation:  {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: "#p-intra-estate__slider--wrapper .swiper-pagination",
                clickable: true,
            },
        })
    }

    divisionSlider(){
        // new Swiper ('.c-card__division--slider .swiper-container',{
        //     loop: true,
        //     effect :'fade',
        //     speed: 2000,
        //     // simulateTouch:false,
        //     autoplay: {
        //         delay: 5000
        //     },
        //     pagination: {
        //         el: ".c-card__division--item .swiper-pagination",
        //         clickable: true,
        //     },
        // })
        document.querySelectorAll('.c-card__division--item .swiper-container').forEach(function(swiperContainer, index) {
            // それぞれのスライダーに対してSwiperを初期化
            new Swiper(swiperContainer, {
                loop: true,
                effect: 'fade',
                speed: 2000,
                autoplay: {
                    delay: 5000
                },
                pagination: {
                    el: swiperContainer.closest('.c-card__division--item').querySelector('.swiper-pagination'),
                    clickable: true,
                },
            });
        });
    }
    golfSlider(){
        new Swiper ('.p-golf__image',{
            allowTouchMove: false,
            freeMode: true,
            loop: true,
            loopedSlides: 10,
            slidesPerView: 2,
            spaceBetween: 10,
            speed: 8000,
            autoplay: {
                delay: 0,
            },
            breakpoints: {
                991: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                767: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                }
            }
        })
    }
    
    
    blogSlider(){
        // const blog_thumbnails = document.querySelectorAll('.blog-slider-thumbnails a');
        // const blogSlider = new Swiper('.js-blog__slider', {
        //     loop: true,
        //     speed:400,
        //     easing:"linear",
        //     loopAdditionalSlides : 5,
        //     slidesPerView: 'auto',
        //     spaceBetween: 20,
        //     simulateTouch:true,
        //     centeredSlides: false,
        //     breakpoints: {
                
        //         576: {
        //             slidesPerView: 'auto',
        //             spaceBetween:  40,
        //         }
        //     }
        // });
        
        // const blogThumbnailAddEvent = (el,i) => {
        //     el.addEventListener('click',function(e){
        //         e.preventDefault();
        //         blogSlider.slideTo(i+1);
        //     })
        // }

        // for(var i = 0; i <  blog_thumbnails.length; i++){
        //     blogThumbnailAddEvent( blog_thumbnails[i],i);
        // }
    }
    pickupSlider(){
        // const pickup = new Swiper('.js-pickup--slider', {
        //     loop: true,
        //     speed:400,
        //     easing:"linear",
        //     loopAdditionalSlides : 5,
        //     slidesPerView: 'auto',
        //     spaceBetween: 20,
        //     simulateTouch:true,
        //     centeredSlides: false,
        //     breakpoints: {
                
        //         576: {
        //             slidesPerView: 'auto',
        //             spaceBetween:  40,
        //         }
        //     }
        // })
    }
    eventSlider(){
        // const SliderContentClass = '.js-event__slider--content'
        // const SliderImageClass = '.js-event__slider--images'
        // const SliderContentNav = document.querySelector(SliderContentClass + ' .swiper--nav')
        // const slides = document.querySelectorAll(SliderImageClass + ' .swiper-slide');
        // if(slides.length > 1){

        //     const EventImageSlider = new Swiper(SliderImageClass, {
        //         effect:'fade',
        //         speed:1500,
        //         easing: "easeInOutExpo",
        //         loop : true
        //     });
        //     const EventContentSlider = new Swiper(SliderContentClass, {
        //         effect:'slide',
        //         navigation:  {
        //             nextEl: SliderContentClass + ' .swiper-button-next',
        //             prevEl: SliderContentClass + ' .swiper-button-prev',
        //         },
                
        //         easing: "easeOutExpo",
        //         speed:1000,
        //         loop : true,
        //         on: {
        //             init: function () {
        //                 SliderContentNav.innerText = 1 + '/' + slides.length
        //             },
        //             slideChange: function () {
        //                 SliderContentNav.innerText = (EventContentSlider.realIndex + 1) + '/' + slides.length
        //             },
        //         },
        //     });

        //     EventImageSlider.controller.control = EventContentSlider;
        //     EventContentSlider.controller.control = EventImageSlider;
        //     EventContentSlider
        // }
    }
}